/* eslint-disable @typescript-eslint/no-explicit-any */

import { baseApi } from '@/api/baseApi';

import type { ListLeadProjectsRequest, ListLeadProjectsResponse } from './types';

const LEAD_V1 = 'lead/v1';

export const leadApi = baseApi.injectEndpoints({
  endpoints: build => ({
    listLeadProjects: build.query<ListLeadProjectsResponse, ListLeadProjectsRequest>({
      query: ({ statusFilter = 'InProgress', page, limit, search }) => ({
        url: `${LEAD_V1}/project/list`,
        params: { statusFilter, page, limit, search },
      }),
      transformResponse: (response: any) => response.data,
      providesTags: ['LeadProject'],
    }),

    uploadProjectImage: build.mutation<any, { file: File; projectId: string }>({
      query: ({ file, projectId }) => {
        const formData = new FormData();
        formData.append('file', file);

        return {
          url: `${LEAD_V1}/${projectId}/uploadDocument`,
          method: 'POST',
          body: formData,
        };
      },
      transformResponse: (response: any) => response.data ?? response,
    }),
  }),
});

export const { useListLeadProjectsQuery, useUploadProjectImageMutation } = leadApi;
